import { UAParser } from 'ua-parser-js';

const getUserAgentDetails = () => {
  const parser = new UAParser();
  return {
    browser: parser.getBrowser(),
    engine: parser.getEngine(),
    os: parser.getOS(),
    device: parser.getDevice(),
    cpu: parser.getCPU(),
  };
};

export default getUserAgentDetails;
